/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeRosterPublishAndLockRostersCtrl
 */
angular.module('mercury.modules.time.roster')
.controller('TimeRosterPublishAndLockRostersCtrl', ["$state", "dialog", "$scope", "Rosters", function($state, dialog, $scope, Rosters) {
  angular.forEach($scope.currentRosters, function(roster) {
    if (roster.datestampPublished != null && roster.datestampLocked != null) {
      roster.publishButtonText = 'Published & Locked';
    } else if (roster.datestampPublished != null) {
      roster.publishButtonText = 'Published';
    } else {
      roster.publishButtonText = 'Publish';
    }
  });

  $scope.getLockButtonText = function(roster) {
    if (roster.datestampLocked != null) {
      return 'Unlock';
    } else {
      return 'Lock';
    }
  };

  $scope.publishButtonClasses = function(roster) {
    if (roster.datestampLocked != null || roster.datestampPublished != null) {
      return 'locked-roster';
    } else {
      return 'green-button';
    }
  };


  $scope.publishAndLockRoster = function(roster) {
    if (roster.datestampLocked != null) {
      dialog.open({
        templateUrl: 'modules/time/roster/unlockRoster.tpl.html',
        controller: 'TimeRosterUnlockRosterCtrl',
        size: 'md',
        scope: $scope,
        resolve: {
          roster: roster
        }
      });
    } else {
      $state.go('Time.RosterPublish', {rosterId: roster.id, start: moment(roster.startDateTime).utc(), end: moment(roster.endDateTime).utc()}, {reload: true});
    }
  };
}]);
